export function stringToFixed(value: string, digits = 2): string {
  const number = parseFloat(value);
  return isNaN(number) ? "" : number.toFixed(digits);
}
